module.exports = new __parcel__URL__("Warlock_38.8a73180e.png").toString();